"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const storm_ui_1 = require("@amzn/storm-ui");
const TranslationProvider_1 = require("../TranslationProvider/TranslationProvider");
const HeaderWrapper = (0, styled_components_1.default)('div') `
  border-bottom: 1px solid ${({ theme }) => theme.color.gray[100]};
  display: flex;
  flex-direction: row;
  justify-content: start;
  padding: 14px 18px;
`;
const Heading = (0, styled_components_1.default)('div') `
  display: flex;
  align-items: center;
  width: fit-content;
  margin-left: initial;
`;
const RegionSelectorHeader = ({ id }) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const header = translate('change-region');
    const tip = translate('tip-blurb');
    return ((0, jsx_runtime_1.jsx)(HeaderWrapper, { children: (0, jsx_runtime_1.jsxs)(Heading, { children: [(0, jsx_runtime_1.jsx)(storm_ui_1.Text, { size: 'medium', children: header }), (0, jsx_runtime_1.jsx)(storm_ui_1.HelpTip, { id: id, position: 'right', children: (0, jsx_runtime_1.jsx)(storm_ui_1.Text, { children: tip }) })] }) }));
};
exports.default = RegionSelectorHeader;
//# sourceMappingURL=RegionSelectorHeader.js.map